<style scoped>
.wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
    @apply font-bold;
}
</style>

<template>
    <div v-if="showBanner" class="wrapper">
        <div class=" text-darkGrayishBlue mr-auto ml-2 sm:ml-6">
            <div class="inline sm:inline-block sm:mr-1">
                {{ $t('register.email.confirm.greet.1') }}
            </div>
            <div class="inline sm:inline-block">
                {{
                    user
                        ? $t(
                              `register.email.confirm.greet.2.${user.custTypeCode}`,
                              user.cmpyName,
                              callingOfCustomer
                          )
                        : previewCmpyName
                        ? $t(
                              'register.email.confirm.greet.2',
                              previewCmpyName,
                              callingOfCustomer
                          )
                        : ''
                }}
            </div>
        </div>
        <slot>
            <div
                v-if="
                    timeoutDate && distance && distance > 0 && !showCountdownMsg
                "
                class="mr-2 ml-2 sm:ml-0 sm:mr-6"
            >
                {{ $t('timeout.message.dlvr', dlvrDate) }}
            </div>
            <div v-else class="text-red mr-2 ml-2 sm:ml-0 sm:mr-6">
                {{
                    timeoutDate && distance && distance > 0
                        ? countdown
                            ? countdownMsg
                            : $t('timeout.message', timeoutDate)
                        : $t('site.beyond.sales.period')
                }}
            </div>
        </slot>
    </div>
</template>

<script>
import formatDate from './formatDateFilter';

export default {
    props: {
        countdown: { type: Boolean, default: true },
        includeSecond: { type: Boolean, default: false }
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
        previewCmpyName() {
            return this.$store.state.previewCmpy?.cmpyName;
        },
        previewCmpyTypeCode() {
            return this.$store.state.previewCmpy?.cmpyTypeCode;
        },
        endDate() {
            if (this.$store.getters.shoppingList) {
                return this.$store.getters.shoppingList.saleEndDate;
            }
            return undefined;
        },
        timeoutDate() {
            return formatDate(this.endDate, 'datetime');
        },
        dlvrDate() {
            var dlvrDate = new Date(this.endDate);
            dlvrDate.setDate(dlvrDate.getDate() + 1);
            return formatDate(dlvrDate, 'date');
        },
        distance() {
            return this.$store.state.saleEndDateDistance;
        },
        salesEndCountDownHour() {
            return this.$store.state.salesEndCountDownHour;
        },
        showBanner() {
            return this.user || this.previewCmpyName;
        },
        showCountdownMsg() {
            return (
                this.distance > 0 &&
                !!this.salesEndCountDownHour &&
                this.salesEndCountDownHour * 1000 * 60 * 60 > this.distance
            );
        },
        countdownMsg() {
            const distance = this.distance;
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor(
                (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
            );
            var minutes = Math.floor(
                (distance % (1000 * 60 * 60)) / (1000 * 60)
            );
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);

            if (distance > 0) {
                return this.showCountdownMsg
                    ? this.$t(
                          'timeout.countdown.message',
                          (days == 0
                              ? ''
                              : this.$t('timeout.countdown.day.part', days)) +
                              (days == 0 && hours == 0
                                  ? ''
                                  : this.$t(
                                        'timeout.countdown.hour.part',
                                        hours
                                    )) +
                              (days == 0 && hours == 0 && minutes == 0
                                  ? ''
                                  : this.$t(
                                        'timeout.countdown.minute.part',
                                        minutes
                                    )) +
                              (this.includeSecond
                                  ? this.$t(
                                        'timeout.countdown.second.part',
                                        seconds
                                    )
                                  : '')
                      )
                    : '';
            } else {
                return this.$t('site.beyond.sales.period');
            }
        },
        callingOfCustomer() {
            return this.$store.getters.getCallingOfCustomer(
                this.user?.cmpyTypeCode || this.previewCmpyTypeCode
            );
        }
    }
};
</script>
